import { HotelBookingPartnerSearch } from './HotelBookingPartnerSearch';

export default HotelBookingPartnerSearch;
